import { useDispatch } from "react-redux";
import { pushAnswer } from "./ducks/readingTest";

export const ReadingTestExamples = ({examples})=>{
    const dispatch = useDispatch();

    const onPushAnswer = (answer)=>{
        dispatch( pushAnswer(answer) );
    }

    return examples.map(function(example, key){
        let keyStr = String(key);
        return (
            <li key={key} className="example" onClick={()=>onPushAnswer(keyStr)}>
                    {key+1}. &nbsp;
                    { (null===example.image || example.image==='' ) && example.name}
                    { ( null!==example.image && example.image!=='' ) && 
                        <img src={`${process.env.PUBLIC_URL}${example.image}`} alt={example.name} />
                    }
            </li>
        );
    });
}